import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEmpty, isEqual } from 'lodash'
import cn from 'classnames'
import Grid from '@material-ui/core/Grid'
import { Icon, IconButton, Button, Collapse } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import {
  PROJECTED_SITES_MANAGER_SEAWATER_FILTERS,
  CLIENT_STORE_NAME,
  REGION_STORE_NAME,
  SITE_STORE_NAME,
  SPECIE_STORE_NAME,
} from 'constants/projectedSitesManager'
import { PROJECTED_SITES_MANAGER } from 'constants/exportTypes'
import {
  fetchProjectedSitesManagerFilters,
  fetchProjectedSitesManagerList,
  setPsfs,
  clearPsfs,
} from 'reducers/projectedSitesManager/reducer'
import Psfs from 'lib/psfs/Psfs'
import ExportButton from 'components/common/ExportButton'
import Pagination from 'lib/psfs/Pagination'
import { FilterComponent } from 'routes/App/Apps/MonitorsAndAlerts/SiteFilters/FilterComponent'
import { ReactComponent as IconFilter } from 'assets/img/open-filters.svg'
import withPromise from 'helpers/withPromise'
import { FILTER_TO_ID, ID_TO_FILTER } from '../constants'
import messages from '../translate'

class SeawaterFilterBar extends Component {
  state = {
    shouldSetFiltersValues: false,
    setInitialData: false,
    isOpenFilters: false,
    showBadge: false,
    showDisabledRows: true,
    firstSelectedFilter: null,
    filtersArr: PROJECTED_SITES_MANAGER_SEAWATER_FILTERS,
    initialData: PROJECTED_SITES_MANAGER_SEAWATER_FILTERS,
  }

  componentWillUnmount() {
    const { clearPsfs } = this.props

    clearPsfs()
  }

  componentDidMount() {
    const {
      setPsfs,
      location: { pathname },
      fetchProjectedSitesManagerFilters,
      siteType,
    } = this.props

    const psfs = new Psfs(pathname)

    setPsfs(psfs)

    withPromise(fetchProjectedSitesManagerFilters, siteType).then(() => {
      this.setFilters()
      const {
        storePsfs: { path },
      } = this.props
      const { initialData } = this.state
      const psfs = new Psfs(path)
      const filters = psfs.filtersObj.getFilters()
      const newFiltersArr = initialData.map(filter => {
        const filterId = FILTER_TO_ID[filter.storeName]
        if (Object.keys(filters).includes(filterId)) {
          const savedFilter = filters[filterId]

          return {
            ...filter,
            value: savedFilter.values.map(item =>
              filter.data.find(el => el[filterId] === +item),
            ),
          }
        }

        return filter
      })

      this.setState(
        {
          filtersArr: newFiltersArr,
          firstSelectedFilter: ID_TO_FILTER[Object.keys(filters).pop()],
          isOpenFilters: !!Object.keys(filters).length,
        },
        () => {
          const data = this.getFiltersData()

          this.fetchDataByFilter(
            data,
            ID_TO_FILTER[Object.keys(filters)[0]],
            false,
          )
        },
      )
    })
  }

  componentDidUpdate(prevProps) {
    const {
      fetchProjectedSitesManagerList,
      storePsfs: newStorePsfs,
      siteType: newSiteType,
      selectedSnapshot: newSelectedSnapshot,
    } = this.props
    const { storePsfs: prevStorePsfs } = prevProps

    if (!isEqual(prevStorePsfs, newStorePsfs)) {
      fetchProjectedSitesManagerList({
        psfs: newStorePsfs,
        siteType: newSiteType,
        snapshot: newSelectedSnapshot,
      })
    }
  }

  setFilters = () => {
    const { seawaterFilters } = this.props
    const { filtersArr, shouldSetFiltersValues } = this.state

    const newFilters = filtersArr.map(filter => {
      const newFilter = { ...filter }
      const { filterType } = filter
      const filterTypes = seawaterFilters.get(filterType)
      const data = filterTypes && filterTypes.map(this.updateListData)
      newFilter.data = data

      if (shouldSetFiltersValues) {
        newFilter.value = data
      } else {
        newFilter.value = []

        this.setState({
          shouldSetFiltersValues: true,
        })
      }

      return newFilter
    })

    this.setState({
      initialData: newFilters,
      filtersArr: newFilters,
    })
  }

  getFiltersData() {
    const { filtersArr } = this.state

    return filtersArr.reduce((acc, { value, storeName: itemStoreName }) => {
      if (value && !!value.length) {
        acc[itemStoreName] = value.map(({ id }) => id)
      }

      return acc
    }, {})
  }

  findEntityMatches = (entity, selectedIds, idType) =>
    entity.filter(entityItem =>
      entityItem[idType].some(id =>
        selectedIds.find(selectedId => selectedId === id),
      ),
    )

  findValueMatch = (data, values, idName) =>
    values.filter(valueItem =>
      data.find(dataItem => dataItem[idName] === valueItem[idName]),
    )

  showBadge = () => {
    const { filtersArr } = this.state
    const showBadge = filtersArr.some(
      ({ value, data }) => value.length !== data.length,
    )

    this.setState({ showBadge })
  }

  resetFilters = event => {
    const {
      setPsfs,
      storePsfs: { path },
      fetchProjectedSitesManagerFilters,
      siteType,
    } = this.props

    event.stopPropagation()

    this.setState(
      () => ({
        setInitialData: true,
        showDisabledRows: true,
        firstSelectedFilter: null,
        showBadge: false,
        shouldSetFiltersValues: false,
      }),
      () => {
        const psfs = new Psfs(path)

        psfs.filtersObj.clearAll()
        psfs.addPagination(1, 100)

        setPsfs(psfs)

        withPromise(fetchProjectedSitesManagerFilters, siteType).then(() => {
          this.setFilters()
        })
      },
    )
  }

  handleClientsFilterChange = values => {
    const { initialData, filtersArr, firstSelectedFilter } = this.state
    const { data: sites } = initialData.find(
      ({ storeName }) => storeName === SITE_STORE_NAME,
    )
    const matchSites = this.findEntityMatches(sites, values, 'clientIds')
    const siteIds = matchSites.map(({ siteId }) => siteId)
    const resultData = {}

    if (firstSelectedFilter === REGION_STORE_NAME) {
      const { value: regionValues } = filtersArr.find(
        ({ storeName }) => storeName === REGION_STORE_NAME,
      )
      const matchRegionValues = regionValues.map(({ region }) => region)
      const matchRegionsValues = this.findValueMatch(
        regionValues,
        matchRegionValues,
        'regions',
      )
      const matchSites = this.findEntityMatches(
        sites,
        matchRegionsValues,
        'regions',
      )
      const clientSiteIds = matchSites.map(({ siteId }) => siteId)

      resultData.site = siteIds.filter(element =>
        clientSiteIds.includes(element),
      )
    } else {
      const { data: regions } = initialData.find(
        ({ storeName }) => storeName === REGION_STORE_NAME,
      )
      const matchRegions = this.findEntityMatches(regions, values, 'clientIds')
      const regionIds = matchRegions.map(({ id }) => id)

      resultData.region = regionIds
      resultData.site = siteIds
    }

    return resultData
  }

  handleRegionsFilterChange = values => {
    const { initialData, filtersArr, firstSelectedFilter } = this.state
    const { data: sites } = initialData.find(
      ({ storeName }) => storeName === 'site',
    )
    const matchSites = this.findEntityMatches(sites, values, 'regions')
    const siteIds = matchSites.map(({ siteId }) => siteId)
    const resultData = {}

    if (firstSelectedFilter === CLIENT_STORE_NAME) {
      const { value: clientValues } = filtersArr.find(
        ({ storeName }) => storeName === CLIENT_STORE_NAME,
      )
      const matchClients = clientValues.map(({ clientId }) => clientId)
      const findClientsValues = this.findValueMatch(
        clientValues,
        matchClients,
        'clientIds',
      )
      const matchSites = this.findEntityMatches(
        sites,
        findClientsValues,
        'clientIds',
      )
      const clientSiteIds = matchSites.map(({ siteId }) => siteId)

      resultData.site = siteIds.filter(element =>
        clientSiteIds.includes(element),
      )
    } else {
      const { data: clients } = initialData.find(
        ({ storeName }) => storeName === CLIENT_STORE_NAME,
      )
      const matchClientsValues = this.findEntityMatches(
        clients,
        values,
        'regions',
      )
      const clientIds = matchClientsValues.map(({ clientId }) => clientId)

      resultData.client = clientIds
      resultData.site = siteIds
    }

    return resultData
  }

  handleSpeciesFilterChange = values => {
    const { filtersArr, initialData, firstSelectedFilter } = this.state
    const { data: sites } = initialData.find(
      ({ storeName }) => storeName === SITE_STORE_NAME,
    )
    let matchSites = this.findEntityMatches(sites, values, 'specieIds')
    const siteIds = matchSites.map(({ siteId }) => siteId)
    let clientSiteIds = []

    if (firstSelectedFilter === CLIENT_STORE_NAME) {
      const { value: clients } = filtersArr.find(
        ({ storeName }) => storeName === CLIENT_STORE_NAME,
      )
      const matchClients = clients.map(({ clientId }) => clientId)
      const matchClientsValues = this.findValueMatch(
        clients,
        matchClients,
        'clientIds',
      )
      matchSites = this.findEntityMatches(
        sites,
        matchClientsValues,
        'clientIds',
      )
    } else if (firstSelectedFilter === REGION_STORE_NAME) {
      const { value: regions } = filtersArr.find(
        ({ storeName }) => storeName === REGION_STORE_NAME,
      )
      const matchRegions = regions.map(({ region }) => region)
      const matchRegionsValues = this.findValueMatch(
        regions,
        matchRegions,
        'regions',
      )
      matchSites = this.findEntityMatches(sites, matchRegionsValues, 'regions')
    }

    clientSiteIds = matchSites.map(({ siteId }) => siteId)
    const mergedSiteIds = siteIds.filter(element =>
      clientSiteIds.includes(element),
    )

    return { site: mergedSiteIds }
  }

  getUpdatedFilters = (updatedData, oldData) => {
    const { filtersArr, initialData } = this.state
    let updatedArr = [...filtersArr]

    if (Object.keys(updatedData).length) {
      Object.keys(updatedData).forEach(dataStoreName => {
        updatedArr = updatedArr.map(item => {
          if (item.storeName === dataStoreName) {
            const idNames = {
              site: 'siteId',
              region: 'id',
              client: 'clientId',
            }
            const matchFromInitial = initialData.find(
              ({ storeName }) => storeName === dataStoreName,
            )

            const getUpdatedData = field =>
              !!matchFromInitial &&
              matchFromInitial[field].filter(data =>
                updatedData[dataStoreName].some(
                  id => id === data[idNames[dataStoreName]],
                ),
              )

            const updatedItemData = getUpdatedData('data')
            const updatedItemValue = oldData
              ? updatedItemData.filter(
                  filter =>
                    oldData[dataStoreName] &&
                    oldData[dataStoreName].includes(
                      filter[idNames[dataStoreName]],
                    ),
                )
              : getUpdatedData('value')

            return {
              ...item,
              data: updatedItemData,
              value: updatedItemValue,
            }
          }

          return item
        })
      })
    }

    if (isEmpty(oldData) && isEmpty(updatedData)) {
      return initialData
    }

    if (oldData && Object.keys(oldData).length === 1 && oldData.site) {
      return filtersArr.map(filter =>
        filter.storeName === SITE_STORE_NAME
          ? {
              ...filter,
              data: initialData.find(
                ({ storeName }) => storeName === SITE_STORE_NAME,
              ).data,
            }
          : filter,
      )
    }

    return updatedArr
  }

  fetchDataByFilter = (data, storeName, isFilterChange = true) => {
    const { showDisabledRows, firstSelectedFilter, filtersArr } = this.state
    const {
      storePsfs: { searchObj, path },
      setPsfs,
    } = this.props
    let updatedData = {}
    const psfs = new Psfs(path)
    psfs.filtersObj.clearAll()
    const selectedFilter = filtersArr.find(
      filter => filter.storeName === storeName,
    )
    const allValues = selectedFilter
      ? selectedFilter.data.map(
          filterData => filterData[FILTER_TO_ID[storeName]],
        )
      : []

    if (!data[storeName] && firstSelectedFilter === storeName) {
      this.setState({ firstSelectedFilter: null })
    }

    const handledValue = data[storeName] || allValues

    if (storeName === CLIENT_STORE_NAME) {
      if (!firstSelectedFilter) {
        this.setState({ firstSelectedFilter: storeName })
      }

      updatedData = {
        ...this.handleClientsFilterChange(handledValue),
      }
    } else if (storeName === REGION_STORE_NAME) {
      if (!firstSelectedFilter) {
        this.setState({ firstSelectedFilter: storeName })
      }

      updatedData = {
        ...this.handleRegionsFilterChange(handledValue),
      }
    } else if (storeName === SPECIE_STORE_NAME) {
      updatedData = {
        ...this.handleSpeciesFilterChange(handledValue),
      }
    }

    const updatedFiltersArr = this.getUpdatedFilters(updatedData, data)

    const psfsData = {}

    Object.keys(data).forEach(psfsFilter => {
      psfsData[psfsFilter] = data[psfsFilter].filter(id =>
        updatedFiltersArr
          .find(filter => filter.storeName === psfsFilter)
          .value.some(val => val[FILTER_TO_ID[psfsFilter]] === id),
      )
    })

    Object.keys(psfsData).forEach(item => {
      if (psfsData[item] && !!psfsData[item].length) {
        if (item === REGION_STORE_NAME) {
          psfs.addFilter('region', psfsData[item], 'in')
        } else if (item === CLIENT_STORE_NAME) {
          psfs.addFilter('clientId', psfsData[item], 'in')
        } else if (item === SITE_STORE_NAME) {
          psfs.addFilter('siteId', psfsData[item], 'in')
        } else if (item === SPECIE_STORE_NAME) {
          psfs.addFilter('specieId', psfsData[item], 'in')
        }
      }
    })

    if (!showDisabledRows) {
      psfs.addFilter('enabled', !showDisabledRows)
    }

    psfs._search = searchObj
    psfs._pagination = new Pagination()
    psfs.addPagination(1, 100)

    this.setState({ filtersArr: updatedFiltersArr })

    if (isFilterChange) {
      setPsfs(psfs)
    }
  }

  handleDeactivateRows = () => {
    const { showDisabledRows, filtersArr, initialData } = this.state
    const {
      storePsfs: { path },
      setPsfs,
    } = this.props
    const psfs = new Psfs(path)
    const showBadge = filtersArr !== initialData || showDisabledRows

    if (showDisabledRows) {
      psfs.addFilter('enabled', showDisabledRows)
    } else {
      psfs.clearFilter('enabled')
    }

    this.setState(
      {
        showDisabledRows: !showDisabledRows,
        showBadge,
      },
      () => {
        setPsfs(psfs)
      },
    )
  }

  handleSetInitialData = flag => {
    this.setState({ setInitialData: flag })
  }

  handleFilterChange = (value, storeName) => {
    const { filtersArr } = this.state
    const newArr = filtersArr.map(item => {
      if (item.storeName === storeName) {
        return {
          ...item,
          value,
        }
      }

      return item
    })

    if (!isEqual(filtersArr, newArr)) {
      this.setState(
        {
          filtersArr: newArr,
        },
        () => {
          const data = this.getFiltersData()

          this.fetchDataByFilter(data, storeName)
          this.showBadge()
        },
      )
    }
  }

  updateData = (data, field, id) => ({
    id: data[id],
    name: data[field],
    storeName: data[field],
    translateName: data[field],
  })

  updateListData = data => {
    let newData = {}

    if (data.clientId) {
      newData = {
        ...data,
        ...this.updateData(data, CLIENT_STORE_NAME, 'clientId'),
      }
    } else if (data.siteId) {
      newData = {
        ...data,
        ...this.updateData(data, 'siteSiep', 'siteId'),
      }
    } else if (data.region) {
      newData = {
        ...data,
        ...this.updateData(data, REGION_STORE_NAME, 'region'),
      }
    } else if (data.specieId) {
      newData = {
        ...data,
        ...this.updateData(data, SPECIE_STORE_NAME, 'specieId'),
      }
    }

    return newData
  }

  toggleFilterBar = () => {
    this.setState(prevState => ({
      isOpenFilters: !prevState.isOpenFilters,
    }))
  }

  renderControls = () => {
    const {
      intl: { formatMessage },
    } = this.props
    const { showBadge, showDisabledRows, isOpenFilters } = this.state

    return (
      <>
        <div className="button" onClick={this.handleDeactivateRows}>
          <Icon>{showDisabledRows ? 'visibility' : 'visibility_off'}</Icon>
          <div className="text">{formatMessage(messages.deactivatedRows)}</div>
        </div>
        <div
          className={cn('button', {
            active: isOpenFilters,
            'has-reset': showBadge,
          })}
          onClick={this.toggleFilterBar}>
          <IconButton className="icon-btn">
            <IconFilter />
          </IconButton>
          <div className="text">{formatMessage(messages.showFilters)}</div>
          {showBadge && (
            <div className="reset-filters" onClick={this.resetFilters} />
          )}
        </div>
      </>
    )
  }

  renderFilters = () => {
    const { setInitialData, filtersArr } = this.state
    const {
      intl: { formatMessage },
    } = this.props

    return filtersArr.map(filter => (
      <Grid item key={filter.id}>
        <FilterComponent
          {...filter}
          allSelectedExistInList
          handleFilterChange={this.handleFilterChange}
          formatMessage={formatMessage}
          disableUnderline={false}
          setInitialData={setInitialData}
          handleSetInitialData={this.handleSetInitialData}
        />
      </Grid>
    ))
  }

  render() {
    const {
      intl: { formatMessage },
      storePsfs,
      onOpenForm,
      siteType,
      selectedSnapshot: snapshot,
    } = this.props
    const { isOpenFilters } = this.state

    const exportButtonParams = {
      psfs: storePsfs,
      type: PROJECTED_SITES_MANAGER,
      siteType,
      snapshot,
    }

    return (
      <>
        <Grid item>
          <Grid container justify="flex-end">
            <Grid item className="controls">
              {this.renderControls()}
            </Grid>
          </Grid>
          <Grid item className="collapsed-filter">
            <Collapse in={isOpenFilters}>{this.renderFilters()}</Collapse>
          </Grid>
        </Grid>
        {snapshot === 'main-table' && (
          <Button
            className="add-row-btn"
            variant="contained"
            color="primary"
            type="button"
            size="medium"
            onClick={() => onOpenForm(null)}>
            {formatMessage(messages.newRow)}
          </Button>
        )}
        <ExportButton params={exportButtonParams} />
      </>
    )
  }
}

export default connect(
  state => ({
    storePsfs: state.getIn(['projectedSitesManager', 'storePsfs']),
    seawaterFilters: state.getIn(['projectedSitesManager', 'seawaterFilters']),
  }),
  {
    setPsfs,
    fetchProjectedSitesManagerList,
    fetchProjectedSitesManagerFilters,
    clearPsfs,
  },
)(injectIntl(SeawaterFilterBar))
